<template>
  <div class="ui form">
    <!-- Area Boundaries and Excludes -->
    <div class="field">
      <div class="global-h4">Area Boundaries</div>
      <p class="cms">(Optional) The area you would like the adventures to stay within (ex. within 10 miles of town, within a specific county).</p>
      <textarea type="text" maxlength="1000" v-model="collabInput.areaBoundaries" style="height: 100px" ref="areaBoundariesTextarea"></textarea>
    </div>
    <div class="field">
      <div class="global-h4">Locations to Exclude</div>
      <p class="cms">(Optional) Are there locations the creator should avoid covering in this visit?</p>
      <textarea type="text" maxlength="1000" v-model="collabInput.excludedAttractions" style="height: 100px"></textarea>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from "vue";
import { CollabInput } from "@contracts/collab";

defineProps({
  collabInput: { type: Object as () => CollabInput | null, required: true },
  errors: { type: Array<string>, required: true },
});

const areaBoundariesTextarea = ref<HTMLInputElement | null>(null);

onMounted(() => {
  nextTick(() => areaBoundariesTextarea.value?.focus());
});
</script>

<style scoped lang="scss">
@import "./form-error-highlight.scss";
</style>
